import {Link} from "react-router-dom";
import styles from "./page.module.css";


const serviceGroups = [
  {
    id: "technical",
    title: "Medical Equipment Sales",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
    ),
    intro: "Infinity generates revenue through multiple complementary business segments.",
    items: [
      {
        title: "MRI Systems",
        description: "",
      },
      {
        title: "CT Scanners",
        description: "",
      },
      {
        title: "Cath Labs",
        description: ""
      },
      {
        title: "Nuclear Medicine Equipment",
        description: "",
      },
      {
        title: "Laboratory Systems",
        descritpiton: ""
      },
      {
        title: "Surgical Solutions",
        descritpiton: ""
      }
    ],
  },
  {
    id: "aftersales",
    title: "Turkey Healthcare Projects",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
    ),
    intro: "End-to-End healthcare infrastructure projects covering: ",
    items: [
      {
        title: "Design Support",
        description: "",
      },
      {
        title: "Construction Coordination",
        description: "",
      },
      {
        title: "Installation",
        description: "",
      },
      {
        title: "Commissioning",
        description: ""
      }
    ],
  },
  {
    id: "training",
    title: "Technical Service Contracts",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
    ),
    intro: "Long-term service agreements providing recurring revenue and strong customer retention.",
    items: [
    ],
  },
  {
    id: "3",
    title: "Spare Parts & Consumables",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
    ),
    intro: "Continuous support through reliable supply of critical replacement parts and healthcare consumables.",
    items: [
     
    ],
  },
  {
    id: "2",
    title: "Infrastructure Projects",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
    ),
    intro: "Medical gas systems, oxygen plants, modular operating rooms, and specialized healthcare facility installations.",
    items: [
     
    ],
  },
  {
    id: "1",
    title: "Why This Model Works? ",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
    ),
    intro: "Each equipment installation creates long-term opportunities for:",
    items: [
      {
        title: "Maintenance Services",
        description: ""
      },
      {
        title: "Spare Parts",
        desciption: ""
      },
      {
        title: "Upgrades",
        description: ""
      },
      {
        title: "Expansion Projects",
        description: "",
      },
      {
        title: "Infrastructure Support",
        description: ""
      }
     ,
    ],
  },
  

];

// export const metadata = {
//   title: "Our Services",
//   description:
//     "Discover Infinity's comprehensive range of services, including technical support, after-sales maintenance, and training programs designed to meet the unique needs of healthcare providers in Ethiopia & Kenya.",
// };
export default function Services() {
  return (
    <main>
      <section className="pageHero">
        <div className="container">
          <span className="pageHeroLabel">Our Services</span>
          <h1 className="pageHeroTitle">End-to-End capabilities, Delivered Seamlessly</h1>
          <p className="pageHeroDesc">
            A Diversified and Sustainable Revenue Model
          </p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          {serviceGroups.map((group, i) => (
            <div key={group.id} className={`${styles.group} ${i < serviceGroups.length - 1 ? styles.groupBorder : ""}`}>
              <div className={styles.groupHead}>
                <span className={styles.groupIcon}>{group.icon}</span>
                <div>
                  <h2 className={styles.groupTitle}>{group.title}</h2>
                  <p className={styles.groupIntro}>{group.intro}</p>
                </div>
              </div>
              <div className={styles.itemsGrid}>
                {group.items.map((item, j) => (
                  <div key={j} className="item">
                    <div className={styles.itemDot} />
                    <div>
                      <h3 className={styles.itemTitle}>{item.title}</h3>
                      <p className={styles.itemDesc}>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <h2 className={styles.ctaTitle}>Ready to Get Started?</h2>
          <p className={styles.ctaDesc}>Contact our team to discuss your equipment and service needs.</p>
          <Link href="/contact" className={styles.ctaBtn}>Contact Us →</Link>
        </div>
      </section>
    </main>
  );
}
